/**
 * Shared geometry for emergency map locations (points + polygon centroids).
 * Used by read-only map and participant status dialog.
 */

export interface BubbleMapLocationLike {
  latitude?: number | null;
  longitude?: number | null;
  polygonGeoJson?: string | null;
}

/** Lat/lng for a point location, or centroid of first polygon ring */
export function positionForBubbleMapLocation(loc: BubbleMapLocationLike): [number, number] | null {
  const poly = loc.polygonGeoJson?.trim();
  if (poly) {
    try {
      const g = JSON.parse(poly) as { coordinates?: number[][][] };
      const ring = g.coordinates?.[0];
      if (ring?.length) {
        let sumLat = 0;
        let sumLng = 0;
        let n = 0;
        for (const c of ring) {
          if (c.length >= 2) {
            sumLng += c[0];
            sumLat += c[1];
            n += 1;
          }
        }
        if (n > 0) {
          return [sumLat / n, sumLng / n];
        }
      }
    } catch {
      return null;
    }
  }
  if (typeof loc.latitude === "number" && typeof loc.longitude === "number") {
    return [loc.latitude, loc.longitude];
  }
  return null;
}
